import { TaskType } from '../../types/interfaces';

import Api from './api';
import ITaskTypesApi from './interfaces/taskTypesApi';

class TaskTypesApi extends Api<TaskType> implements ITaskTypesApi {
  constructor(abortController: AbortController) {
    super('taskType/', abortController);
  }
}

export default TaskTypesApi;
